// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../../../src/environments/environment';
import { AuthService } from '../../auth/_services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router,private authService: AuthService,) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)   {                    
        let role = localStorage.getItem(btoa('userrole'));	
        role = atob(role);	
        let userrolekey = localStorage.getItem(btoa('userrolekey'));	
        userrolekey = atob(userrolekey);        
        
        // if (window.location.href.includes('attorney') && role && role === environment.admin && userrolekey === environment.userrolekeyadmin) {
        //     localStorage.clear();
        //     this.router.navigate(['/auth/attorney/login']);
        //     return false;
        // } else if (!window.location.href.includes('attorney') && role && role === environment.attorney && userrolekey === environment.userrolekeyattorney) {
        //     localStorage.clear();
        //     this.router.navigate(['/auth/login']);
        //     return false;
        // }

        const currentUser = localStorage.getItem('currentUser');

        if (currentUser) {
            // check auth is set and try access login page whose role is not attorney will logout
            if(this.router.url == '/auth/attorney/login' && role != 'attorney'){
                this.authService.logout();
                this.router.navigate(['/auth/attorney/login']);
                return false;
            }
            // authorised so return true
            return true;
        }        
        const path = window.location.pathname;        
        if (path != '/auth/login') {
            localStorage.setItem('path',path);
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/auth/login']);
        return false;
    }
}
